var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8963 9.9872H20.1243V9.94743H11.4993V13.7808H16.9154C16.1252 16.0122 14.002 17.6141 11.4993 17.6141C8.32391 17.6141 5.74935 15.0395 5.74935 11.8641C5.74935 8.68866 8.32391 6.1141 11.4993 6.1141C12.9651 6.1141 14.2986 6.66705 15.314 7.57028L18.0246 4.85964C16.3131 3.26449 14.0236 2.28076 11.4993 2.28076C6.20695 2.28076 1.91602 6.5717 1.91602 11.8641C1.91602 17.1565 6.20695 21.4474 11.4993 21.4474C16.7917 21.4474 21.0827 17.1565 21.0827 11.8641C21.0827 11.2215 21.0166 10.5943 20.8963 9.9872Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02148 7.40353L6.17009 9.71264C7.02205 7.60335 9.08534 6.1141 11.4999 6.1141C12.9656 6.1141 14.2992 6.66705 15.3145 7.57028L18.0252 4.85964C16.3136 3.26449 14.0241 2.28076 11.4999 2.28076C7.8189 2.28076 4.62669 4.35891 3.02148 7.40353Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5003 21.4469C13.9757 21.4469 16.2249 20.4996 17.9255 18.9591L14.9594 16.4492C13.9973 17.178 12.8013 17.6136 11.5003 17.6136C9.00769 17.6136 6.89121 16.0242 6.09388 13.8062L2.96875 16.214C4.55479 19.3175 7.77575 21.4469 11.5003 21.4469Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8969 9.98655H20.125V9.94678H11.5V13.7801H16.916C16.5365 14.852 15.847 15.7763 14.9577 16.4495C14.9581 16.4491 14.9586 16.4491 14.9591 16.4486L17.9251 18.9585C17.7153 19.1492 21.0833 16.6551 21.0833 11.8634C21.0833 11.2209 21.0172 10.5937 20.8969 9.98655Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social-google.768a1093d57a1cf45e4c4ffb3701afb7.svg";
export { ForwardRef as ReactComponent };